/**
 *
 * @page 用户中心/我的消息/互动消息
 *
 **/
import { useLocation, useHistory } from 'react-router-dom';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import { useStoreState } from '&/utils/customHooks';
import InteractiveMsg from './InteractiveMsg';
import StewardMsg from './StewardMsg';

import './index.scss';

function InteractiveMsgTabs() {
    const { organization = {} } = useStoreState('appStore');

    const disabled =
        organization.example === 0 && organization.roleFlag !== 'admin';
    const headerRight = (
        <button
            className={`text-btn${disabled ? ' type--disabled' : ''}`}
            onClick={() => !disabled && markAsRead()}>
            {intl.get('userCenter.markAllRead')}
        </button>
    );

    const TABS = [
        {
            name: intl.get('userCenter.interactiveMsg'),
        },
        {
            name: intl.get('message.stewardMessage'),
        },
    ];
    const interactive = useRef();
    const steward = useRef();
    const [current, setCurrent] = useState(0);

    const location = useLocation();
    const history = useHistory();
    const tab = new URLSearchParams(location.search).get('tab');
    useEffect(() => {
        if (!tab) return;
        setCurrent(+tab);
        history.replace(location.pathname);
    }, [location.search]);

    const onTabChange = (item, idx) => {
        setCurrent(idx);
    };

    function markAsRead() {
        [interactive, steward][current].current?.markAsRead();
    }

    const COMPONENTS = [
        <InteractiveMsg ref={interactive} />,
        <StewardMsg ref={steward} dop={2} />,
    ];

    return (
        <BasePageWrap
            type="card"
            defaultActive={current}
            className="interactive-msg"
            onTabChange={onTabChange}
            tabs={TABS}
            headerRight={headerRight}>
            {COMPONENTS[current]}
        </BasePageWrap>
    );
}

export default InteractiveMsgTabs;
